import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { KeycloakService } from './keycloak.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: false
})
export class LoginComponent implements OnInit {

  user: string | undefined;
  pass: string | undefined;

  constructor(
    private ls: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private keycloak: KeycloakService
  ) {}

  public login(): void {
    if (!this.user || !this.pass) {
      console.log('User and password are required');
      return;
    }

    this.ls.login(this.user, this.pass).subscribe({
      next: () => {
        this.router.navigate(['map/1']);
      },
      error: (error: any) => console.log(error)
    });
  }

  ngOnInit() {
    const subject = KeycloakService.auth?.authz?.subject;

    if (!subject) {
      console.log('No Keycloak subject available');
      return;
    }

    this.ls.keycloaklogin(subject).subscribe({
      next: () => {
        this.router.navigate(['map/1']);
      },
      error: (error: any) => console.log(error)
    });
  }
}